// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._19pkxy5q{margin-top:var(--ds-space-400,2pc)}\n._1e0c1n7u{display:inline-grid}\n._4cvr1h6o{align-items:center}\n._6a6z1h6o{justify-items:center}\n._otyrpxbi{margin-bottom:var(--ds-space-200,1pc)}\n._y3gn1h6o{text-align:center}", ""]);
// Exports
module.exports = exports;
